import { call, takeLatest } from 'redux-saga/effects';
import { fetchWorkflowList } from '@api/workflows';
import {
  fetchWorkflows,
  fetchWorkflowsFailure,
  fetchWorkflowsSuccess,
} from './workflows.slice';
import { Resp, dispatch } from '../helpers';

export function* workflowsWorker() {
  try {
    const workflows: Resp<typeof fetchWorkflowList> =
      yield call(fetchWorkflowList);
    yield dispatch(fetchWorkflowsSuccess(workflows.data));
  } catch (error) {
    yield dispatch(fetchWorkflowsFailure(error as Error));
  }
}

export function* workflowsSaga() {
  yield takeLatest(fetchWorkflows.type, workflowsWorker);
}
